import { render, staticRenderFns } from "./CertificatedTest.vue?vue&type=template&id=6398a796&scoped=true&"
import script from "./CertificatedTest.vue?vue&type=script&lang=js&"
export * from "./CertificatedTest.vue?vue&type=script&lang=js&"
import style0 from "./CertificatedTest.vue?vue&type=style&index=0&id=6398a796&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6398a796",
  null
  
)

export default component.exports